export default {
  signals: 'Signale',
  axes: 'Achsen',
  addAxis: 'Achse hinzufügen',
};
